







































































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { Organization } from '@/common/Organizations';

import Loading from '@/components/Global/Loading.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Search from '@/components/Staff/Payments/Search.vue';

@Component({
	name: 'OrgManagement',
	components: {
		Welcome,
		Loading,
		Search,
	},
})
export default class OrgManagement extends Vue {
	@State('organizations', { namespace: 'Organizations' })
	private organizations: Organization[] = undefined;

	private filteredOrganizations: Organization[] = [];
	private paginate: string[] = ['setupOrgs'];
	private loading: boolean = true;
	private agenciesOnly: boolean = false;
	private search: string = '';
	private paginateKey: string = '';

	private async created() {
		try {
			await this.$store.dispatch('Organizations/getOrganizations');
			this.loading = false;
			this.filteredOrganizations = this.organizations;
		} catch (e) {
			console.log(e);
		}
	}

	private openOrganization(orgId: string) {
		this.$router.push({
			name: 'stafforganizationtabbed',
			params: {
				org_id: orgId,
			},
		});
	}
}
